import { getLocaleSuffix } from "Utils/translationLoader"

export const getAuditRecoNotification = (currentUser, trad, fullAuditReco) => {
  if (!fullAuditReco) return {}
  const { nonConformity, tasks, actionPlan } = fullAuditReco
  if (!Array.isArray(tasks) || !nonConformity) return {}
  const usersIdsToNotif = tasks.map(task => task?.inChargeUserId)
  const uniqUsersIds = [...new Set(usersIdsToNotif)]
  const localeSuffix = `_${getLocaleSuffix(currentUser?.LANGUAGE_ID)}`
  return {
    to_principals: uniqUsersIds?.map(id => {
      return `user:${id}`
    }),
    data: {
      event: trad?.A_CREER_AUDIT_RECO,
      elementInBold: `${nonConformity?.name}`,
      byUser: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME}`,
      infos: ``,
      email: {
        url: `https://pocketstudio.pocketresult.com/`,
        event: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME} ${trad?.A_CREER_AUDIT_RECO}, ${trad?.ELLE_A_REFERENCE}`,
      },
    },
    ephemeral: false,
    channel_id: "complication_created" + localeSuffix,
  }
}
